import { ItemAppearanceController } from '../appearance/ItemAppearanceController';
import { CareItemEntity, EntityManager } from '../logic/EntityManager';
import SceneManager from '../logic/SceneManager';
import { PositionController } from '../position/PositionController';

export class CareItemController {
  public readonly position: PositionController;
  public readonly appearance: ItemAppearanceController;

  constructor(
    sceneManager: SceneManager,
    protected entity: CareItemEntity,
  ) {
    this.position = new PositionController(sceneManager, entity);
    this.appearance = new ItemAppearanceController(entity);
  }

  public destroy() {
    this.position.destroy();
    EntityManager.deleteEntity(this.entity.entityId);
  }
}
